import { render, staticRenderFns } from "./RoomScreenDetailV2.vue?vue&type=template&id=04033be0&scoped=true&"
import script from "./RoomScreenDetailV2.vue?vue&type=script&lang=js&"
export * from "./RoomScreenDetailV2.vue?vue&type=script&lang=js&"
import style0 from "./RoomScreenDetailV2.vue?vue&type=style&index=0&id=04033be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04033be0",
  null
  
)

component.options.__file = "RoomScreenDetailV2.vue"
export default component.exports